import React from 'react';
export function StringValueRenderer(props) {
  const {
    value
  } = props;
  return typeof value === 'string' ? value : null;
}
export default {
  id: 'Rich.Text.Editor.ValueRenderer.String',
  valueType: 'string',
  Component: StringValueRenderer
};